import { match } from 'fuzzy';
import sortBy from 'lodash/sortBy';

export interface ScoredTreeNode {
  score: number;
  propagatedScore: number;
  children: ScoredTreeNode[];
}

export const fuzzyScore = (search: string, text: string): number => {
  return match(search, text)?.score ?? 0;
};

export const filterScoredTree = <T extends ScoredTreeNode>(tree: T[]): T[] => {
  return tree
    .filter(node => node.propagatedScore > 0)
    .map(node => ({
      ...node,
      children: node.score > 0 ? node.children : filterScoredTree(node.children as T[])
    }));
};

export const sortScoredTree = <T extends ScoredTreeNode>(tree: T[], getSortLabel: (node: T) => string): T[] => {
  return sortBy(
    tree,
    node => -node.propagatedScore,
    node => getSortLabel(node).toLowerCase()
  ).map(node => ({
    ...node,
    children: sortScoredTree(node.children as T[], getSortLabel)
  }));
};
